import React, { Suspense, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import './assets/commonCss/common.less';
import './App.css';
import './Common.css';
import routers from "./routers";
import Listener from './utils/listener';
import NetworkConnectedStatus from './utils/networkConnect';
import { getRoleFromLocation } from '@/utils/commonUtils';
import GlobalDialog from '@/components/GlobalDialog';
import TopPopupForNotification from '@/components/TopPopupForNotification';
import TaskUnlockDialog from '@/components/TaskUnlockDialog';
import TapDetector from '@/components/TapDetector';
import BugReportModal from '@/components/BugReportModal';
import NotFoundPage from '@/components/404Page';
import RouteGuard from '@/components/RouteGuard';
import useLogoutTimer from '@/hooks/useLogoutTimer';
import { initTimeSync } from './utils/timeSync';
import { getUrls } from './utils/getUrls';

initTimeSync(getUrls().BASE_URL);

function App() {
  // 注册监听器
  useLogoutTimer();
  const role = getRoleFromLocation() || 'client';
  const [bugReportVisible, setBugReportVisible] = useState(false);
  function renderRouter(router, index) {
    if (router.children) {
      return (
        <Route
          path={router.path}
          element={
            router.needInterceptor
              ? (
                <RouteGuard role={role} >
                  <Suspense fallback={<div>Loading...</div>}>
                    {router.component}
                  </Suspense>
                </RouteGuard>
              )
              : (
                <Suspense fallback={<div>Loading...</div>}>
                  {router.component}
                </Suspense>
              )
          }
          key={index}
        >
          {
            router.children.map(item => renderRouter(item))
          }
        </Route>
      )
    }
    return (
      <Route
        key={router.path}
        path={router.path}
        element={
          router.needInterceptor
            ? (
              <RouteGuard role={role} >
                <Suspense fallback={<div>Loading...</div>}>
                  {router.component}
                </Suspense>
              </RouteGuard>
            )
            : (
              <Suspense fallback={<div>Loading...</div>}>
                {router.component}
              </Suspense>
            )
        }
        index={router.index === 'true'}
      />
    )
  }

  return <>
    <Router>
      <TapDetector onThresholdReached={() => setBugReportVisible(true)}>
        <Routes>
          {
            routers.map((router, index) => renderRouter(router, index))
          }
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Listener />
        <NetworkConnectedStatus />
        <GlobalDialog />
        <TopPopupForNotification />
        <TaskUnlockDialog />
        <BugReportModal visible={bugReportVisible} onClose={() => setBugReportVisible(false)} />
      </TapDetector>
    </Router>
  </>
}

export default App;
